import {
  Component,
} from '@angular/core';
import { Store } from '@ngrx/store';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { selectConfigSitesFilters
} from '../../../../features/config/config.selectors';
import {
  setConfigDisplaySitesFilters
} from '../../../../features/config/config.actions';



@Component({
    selector: 'site-list-header',
    templateUrl: './site-list-header.component.html',
    styleUrls: ['./site-list-header.component.scss'],
    standalone: false
})
export class SiteListHeaderComponent {

  sitesFiltersDefined: boolean = false;

  constructor(private store: Store) {
    this.initHandleConfig();
  }

  private initHandleConfig(): void {
    this.store.select(selectConfigSitesFilters)
      .pipe(takeUntilDestroyed())
      .subscribe((sitesFilters: any) => {
        this.sitesFiltersDefined = (sitesFilters != undefined);
      });
  }

  openFilters(): void {
    this.store.dispatch(setConfigDisplaySitesFilters({display: true}))
  }

}
